import { openDB, DBSchema } from 'idb';

interface ChatHistoryDB extends DBSchema {
  'quantum-chats': {
    key: number;
    value: {
      timestamp: number;
      thought: string;
      response: string;
    };
  };
}

const dbPromise = openDB<ChatHistoryDB>('quantum-memory', 1, {
  upgrade(db) {
    db.createObjectStore('quantum-chats', {
      keyPath: 'timestamp'
    });
  },
});

export const idb = {
  async getAllChats() {
    console.log(`[${new Date().toISOString()}] %c📚 Retrieving quantum memory`, 'color: #00ff88');
    const db = await dbPromise;
    const chats = await db.getAll('quantum-chats');
    console.log(`[${new Date().toISOString()}] %c📚 Retrieved ${chats.length} quantum memories`, 'color: #00ff88');
    return chats;
  },

  async addChat(chat: { timestamp: number; thought: string; response: string }) {
    console.log(
      `[${new Date().toISOString()}] %c💾 Storing quantum memory`,
      'color: #00ff88',
      {
        timestamp: new Date(chat.timestamp).toISOString(),
        thoughtLength: chat.thought.length,
        responseLength: chat.response.length
      }
    );
    const db = await dbPromise;
    await db.add('quantum-chats', chat);
    console.log(`[${new Date().toISOString()}] %c💾 Quantum memory stored successfully`, 'color: #00ff88');
  },

  async clearChats() {
    console.log(`[${new Date().toISOString()}] %c🧹 Clearing quantum memory bank`, 'color: #ff8800');
    const db = await dbPromise;
    await db.clear('quantum-chats');
    console.log(`[${new Date().toISOString()}] %c🧹 Quantum memory bank cleared`, 'color: #ff8800');
  },

  async getRecentChats(limit: number = 5) {
    console.log(`[${new Date().toISOString()}] %c📚 Retrieving recent quantum memories`, 'color: #00ff88');
    const db = await dbPromise;
    const chats = await db.getAll('quantum-chats');
    // Sort by timestamp descending and take the most recent ones
    const recentChats = chats
      .sort((a, b) => b.timestamp - a.timestamp)
      .slice(0, limit);
    console.log(`[${new Date().toISOString()}] %c📚 Retrieved ${recentChats.length} recent quantum memories`, 'color: #00ff88');
    return recentChats;
  }
}; 